import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Calendar, Settings } from 'lucide-react';
import dayjs from 'dayjs';

export default function CycleRenewalBanner({ renewalInfo, onDismiss }) {
  const navigate = useNavigate();

  if (!renewalInfo) return null;

  const formattedStart = dayjs(renewalInfo.newStart).format('M/D/YYYY');
  const formattedEnd = dayjs(renewalInfo.newEnd).format('M/D/YYYY');

  return (
    <div className="bg-white rounded-card shadow-sm border-l-4 border-secondary p-6 mb-6 transition-all duration-300 hover:shadow-lg">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <div className="bg-secondary/10 rounded-full p-2">
            <Calendar className="h-6 w-6 text-secondary" />
          </div>
        </div>
        <div className="ml-4 flex-1">
          <h3 className="text-lg font-semibold text-gray-900">
            🎉 Welcome to your new certification cycle!
          </h3>
          <div className="mt-2 text-sm text-gray-700">
            <p>
              Your cycle has been automatically renewed: <strong className="text-gray-900">{formattedStart} - {formattedEnd}</strong>
            </p>
            <p className="mt-2">
              All CEUs from your previous cycle have been archived and are still accessible.
            </p>
          </div>
          <div className="mt-4 flex flex-wrap gap-3">
            <button
              onClick={() => navigate('/profile')}
              className="inline-flex items-center gap-2 px-4 py-2 border-2 border-primary text-primary rounded-lg hover:bg-primary/5 transition-all duration-300 text-sm font-semibold"
            >
              <Calendar className="h-4 w-4" />
              Update Cycle Dates
            </button>
            <button
              onClick={() => navigate('/settings')}
              className="inline-flex items-center gap-2 px-4 py-2 border-2 border-primary text-primary rounded-lg hover:bg-primary/5 transition-all duration-300 text-sm font-semibold"
            >
              <Settings className="h-4 w-4" />
              Apply Extension
            </button>
          </div>
        </div>
        <div className="ml-auto pl-3">
          <button
            onClick={onDismiss}
            className="rounded-lg p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-offset-2"
          >
            <span className="sr-only">Dismiss</span>
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
